<template>

    <dropdown-search-menu :options="{
            inputIcon: 'fas fa-coins',
            placeholder: __('labels.kooi.base.selling_agent'),
            title_clear: 'Clear',
        }"
        :keys="columns"
        :selectkeys="['name']"
        setref="selling_agent"
        v-model:search="search"
        :selected="selValue"
        :values="users"
        :is-loading="users_loading"
        @update:search="searchUsers($event)"
        :selectElementOnUnfocus="valTrue"
        @dropdown:new="$store.commit('users/addNew', true)"
        @dropdown:select="select"
        @dropdown:clear="clearValues()"
        @menu:loadmore="$store.dispatch('users/load')"
        cy="agent"
        >
        <slot name="label" >

        </slot>
    </dropdown-search-menu>
</template>
<script>
export default {
    props: {
        value : {}
    },
    components: {

    },
    setup() {

    },
    data() {
        return {

            search: "",
            selValue : "",
            selected: {
                name : "",
                id : 0,
            },
            debounce : {
                users : null,
            }
        }
    },
    mounted() {
        if(this.value && this.value.id){
            this.selected.id = this.value.id;
            this.selected.name = this.value.name;
            this.search = this.value.name;
        }
        this.$store.dispatch("users/minimal_load");
    },
    methods: {
        clearValues(){
            this.selValue = 0;
            this.selected.name ="";
            this.selected.id = null;
            this.search = "";
            this.$emit('update:value', this.selected)
            this.$emit("dropdown:clear");
        },
        select(event, event2){
            this.selValue = event.id;
            this.selected.name = event.name;
            this.selected.id = event.id;
            this.search = event2;
            this.$emit('update:value', this.selected)
        },
        searchUsers(event){

            if (this.debounce.users){
                clearTimeout(this.debounce.users);
            }

        this.debounce.users = setTimeout(() => {
            this.$store.commit("users/setSearch", event);
            this.$store.dispatch("users/minimal_load");
        }, 300); // delay
    }
    },
    computed: {
        valTrue(){
            return true;
        },
        columns() {
            return this.$store.state.users.infinity.columns;
        },
        users() {
            return this.$store.state.users.list;
        },
        users_loading() {
            return !this.$store.state.users.loaded;
        },
    }
}
</script>
